// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentVerification-root-ELop1 {
  padding-left: 20px;
  padding-right: 20px;
}

.DocumentVerification-container-hoqb4 {
  margin: 0 auto;
  padding-top: 30px;
  max-width: var(--max-content-width);
}

.DocumentVerification-infoTitle-Ob8bl {
  color: var(--primary-foreground);
  font-size: 20px;
  margin-bottom: 20px;
  margin-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/routes/documentVerification/DocumentVerification.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.container {\n  margin: 0 auto;\n  padding-top: 30px;\n  max-width: var(--max-content-width);\n}\n\n.infoTitle {\n  color: var(--primary-foreground);\n  font-size: 20px;\n  margin-bottom: 20px;\n  margin-top: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DocumentVerification-root-ELop1`,
	"container": `DocumentVerification-container-hoqb4`,
	"infoTitle": `DocumentVerification-infoTitle-Ob8bl`
};
module.exports = ___CSS_LOADER_EXPORT___;
